export default {
    "war": require("./war").default,
    "pirates": require("./pirates").default,
    "hero": require("./hero").default,
    "ember": require("./ember").default,
    "teach": require("./teach").default,
    //"playground": require("./playground").default,
}
